import React from 'react';
import { PaginationContext } from 'src/providers';

export function usePagination() {
  return React.useContext(PaginationContext);
}
